import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, contentBlockShadow } from '../../../theme';

const AVATAR = '/hub/checklist/fig_avatar.png';

/** Hero card for a foster who has completed every checklist task. No upgrade action by design. */
function CompletionCard({ orgName }: { orgName?: string }) {
  return (
    <Box
      sx={{
        bgcolor: '#fff',
        borderRadius: '12px',
        boxShadow: contentBlockShadow,
        p: { xs: 2.5, lg: '24px 28px' },
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        alignItems: 'center',
        textAlign: { xs: 'center', lg: 'left' },
        gap: { xs: 1.75, lg: 2.75 },
      }}
    >
      <Box
        component="img"
        src={AVATAR}
        alt=""
        sx={{
          width: { xs: 72, lg: 84 },
          height: { xs: 72, lg: 84 },
          borderRadius: '50%',
          flexShrink: 0,
          objectFit: 'cover',
          bgcolor: colors.secondary[50],
        }}
      />
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontWeight: 700, fontSize: { xs: 19, lg: 22 }, lineHeight: 1.2 }}>
          Congratulations on Completing Your 30-Day Checklist! 🎉
        </Typography>
        <Typography sx={{
          fontSize: { xs: 13.5, lg: 14.5 }, color: 'text.secondary', mt: 0.75, lineHeight: 1.5, maxWidth: 520,
        }}
        >
          {`You've built a strong foundation and ${orgName || 'your organization'} is lucky to have you as a foster parent!`}
        </Typography>
      </Box>
    </Box>
  );
}

export default CompletionCard;
